import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@toevla-webapplications/core';

@Component({
	selector: 'ivva-newsletter',
	templateUrl: './newsletter.component.html',
	styleUrls: ['./newsletter.component.scss'],
	imports: [TranslateModule, CoreModule],
})
export class NewsletterComponent {}
